import { Box } from '@chakra-ui/react'
import React, { FC } from 'react'

import { H1 } from '~shared-components/components'

export interface HeaderProps {
  children?: never
  title: string
}

export const Header: FC<HeaderProps> = ({ title }) => (
  <Box>
    <H1
      data-testid="page-header"
      fontSize="28px"
      fontWeight="bold"
      m="0 !important"
      p={0}
    >
      {title}
    </H1>
  </Box>
)
Header.displayName = 'ListPage.Header'
